import {createStore, applyMiddleware, combineReducers} from 'redux';
import { persistCombineReducers, persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { createReduxHistoryContext } from "redux-first-history";
import { reducer as toastr } from 'react-redux-toastr';
import thunk from 'redux-thunk';
import {createHashHistory} from 'history';

import categories from './views/Categories/reducer';
import products from './views/Products/reducer';
import reviews from './components/Reviews/reducer';
import cart from './views/Cart/reducer';
import variations from './components/Variations/reducer';
import search from './views/Search/reducer';
import navtopbar from './components/NavTopBar/reducer';
import navbottombar from './components/NavBottomBar/reducer';
import address from './components/AddressCard/reducer';
import shipping from './components/ShippingCard/reducer';
import payment from './views/Checkout_2_StepPayment/reducer';
import discount from './components/CouponCard/reducer';
import tasks from './views/Tasks/reducer';
import userLogin from './components/UserLogin/reducer';
import userLocation from './components/GeoLocation/reducer';
import orders from './views/Orders/reducer';
import faq from './views/FAQ/reducer';
import formReducer from "./views/EditProfile/reducer";
import yearReducer from "./views/Profile/reducer";

export const mergeObjectArrays = (fromArray, toArray) => {

    let newArray = structuredClone(toArray);
    _.forEach(fromArray, (element) => {
        const index = newArray.findIndex(x => x.id === element.id);
        if (index !== -1)
            newArray[index] = element;
        else
            newArray.push(element);
    });

    // console.log('mergeObjectArrays', toArray, fromArray, newArray);
    return newArray;
}

const { createReduxHistory, routerMiddleware, routerReducer } =
    createReduxHistoryContext({
        history: createHashHistory(),
        savePreviousLocations: 2,
});

const rootPersistConfig = {
  key: 'root',
  storage,
  blacklist: [
        'navtopbar',
        'navbottombar',
        'toastr',
        'router',
  ],
   //debug: true,
};

const rootReducer = persistCombineReducers(rootPersistConfig, {
  categories: persistReducer(
    {
      key: 'categories',
      storage,
      blacklist: ['isFetching', 'hasMore'],
    },
    categories,
  ),
  products: persistReducer(
    {
      key: 'products',
      storage,
      blacklist: ['isFetching', 'hasMore'],
    },
    products,
  ),
  reviews: persistReducer(
    {
      key: 'reviews',
      storage,
      blacklist: ['isFetching'],
    },
    reviews,
  ),
  variations: persistReducer(
    {
      key: 'variations',
      storage,
      blacklist: ['isFetching'],
    },
    variations,
  ),
  cart: persistReducer(
    {
      key: 'cart',
      storage,
    },
    cart,
  ),
  navtopbar,
  navbottombar,
  search: persistReducer(
      {
          key: 'search',
          storage,
      },
      search,
  ),
  toastr,
  address: persistReducer(
    {
      key: 'address',
      storage,
    },
    address,
  ),
  shipping: persistReducer(
    {
      key: 'shipping',
      storage,
    },
    shipping,
  ),
  payment: persistReducer(
    {
      key: 'payment',
      storage,
    },
    payment,
  ),
  discount: persistReducer(
    {
      key: 'discount',
      storage,
    },
    discount,
  ),
  tasks: persistReducer(
    {
      key: 'tasks',
      storage,
      blacklist: ['isFetching', 'hasMore'],
    },
    tasks,
  ),
  userLogin: persistReducer(
        {
            key: 'userLogin',
            storage,
        },
        userLogin,
    ),
  userLocation: persistReducer(
    {
      key: 'userLocation',
      storage,
    },
    userLocation,
  ),
  orders: persistReducer(
        {
            key: 'orders',
            storage,
        },
        orders,
    ),
    faq: persistReducer(
        {
            key: 'faq',
            storage,
            blacklist: ['isFetching', 'hasMore'],
        },
        faq,
    ),
    formReducer: persistReducer(
        {
            key: 'formReducer',
            storage,
        },
        formReducer,
    ),
    yearReducer: persistReducer(
        {
            key: 'year',
            storage,
        },
        yearReducer,
    ),
  router: routerReducer,
});


export const store = createStore(
    rootReducer,
    undefined,
    applyMiddleware(thunk, routerMiddleware)
);

export const routerHistory = createReduxHistory(store);
export const persistor = persistStore(store);
